function initializeSwiperForContainer(container) {
   if (window.innerWidth <= 767) {
    const productImagesSliderWrap = container.querySelector('.swiper-wrapper');
    const slides = Array.from(productImagesSliderWrap.children);
    
    if (slides.length > 1) {
      const lastSlide = slides.pop();
      productImagesSliderWrap.insertBefore(lastSlide, slides[0]);
    }
  }
  // return new Swiper(container, {
  //   loop: true,
  //   slidesPerView: 1,
  //   navigation: {
  //     nextEl: container.querySelector('.swiper-button-next'),
  //     prevEl: container.querySelector('.swiper-button-prev'),
  //   },
  //   pagination: {
  //     el: '.swiper-pagination',
  //     type: 'bullets',
  //    clickable: true,
  //   },
  // });
}

// function initializeProductSwipers() {
//   const productCards = document.querySelectorAll('.main-collection-images-wrap');
  
//   productCards.forEach((container) => {
//     if (!container.swiper) {
//       initializeSwiperForContainer(container);
//     }
//   });
// }

// document.addEventListener('DOMContentLoaded', initializeProductSwipers);
  
// function destroySwiperForContainer(container) {
//   if (container.swiper) {
//     container.swiper.destroy(true, true);
//     container.swiper = null;
//   }
// }

function setupColorSwatchEvents(colorSwatches) {
  // const colorSwatches = document.querySelectorAll('.color-swatch');
  colorSwatches.forEach(swatch => {
    swatch.addEventListener('click', function() {
          const productCardWrapper = this.closest('.product-card-wrapper');
          const siblingSwatches = productCardWrapper.querySelectorAll('.color-swatch');
          siblingSwatches.forEach(s => s.classList.remove('selected'));
          this.classList.add('selected');          
          
          const selectedColor = this.getAttribute('data-color');
          const variantAvailable = this.getAttribute('data-main-variant-available');
          const variantImage = this.getAttribute('data-variant-image');
          const variantImageSrcset = this.getAttribute('data-variant-image-srcset');
          const variantPrice = this.getAttribute('data-variant-price');
          const cardProductPrice = productCardWrapper.querySelector('.price')
          const variantSlides = this.getAttribute('data-swiper-slides');
          const firstImage = productCardWrapper.querySelector('img.first-image');
          const hoverProductImagesSlider = productCardWrapper.querySelector('.main-collection-images-wrap');
          const variantSecondImageSrcset = this.getAttribute('data-variant-second-image-srcset');
          const variantSecondImage = this.getAttribute('data-variant-second-image');
          const saleBadge = productCardWrapper.querySelector('.card__badge');
          const hoverSecondImage = productCardWrapper.querySelector('img.hover-second-image');
          const savedAmount = this.getAttribute('data-saved-amount');
          const savedAmountWrap = productCardWrapper.querySelector('.custom-saved-amount')
          if (firstImage) {
              firstImage.src = variantImage;
              firstImage.srcset = variantImageSrcset;
          }
          // if (hoverSecondImage) {
          //     hoverSecondImage.src = variantSecondImage;
          //     hoverSecondImage.srcset = variantSecondImageSrcset;
          // }
          // if (hoverProductImagesSlider) {
          //   const productImagesSliderWrap = hoverProductImagesSlider.querySelector('.swiper-wrapper')
          //   destroySwiperForContainer(hoverProductImagesSlider);
          //   productImagesSliderWrap.innerHTML = '';
          //   productImagesSliderWrap.innerHTML = variantSlides;
          //   initializeSwiperForContainer(hoverProductImagesSlider);
          // }

        if(cardProductPrice && variantPrice){
            cardProductPrice.innerHTML = variantPrice
          }

       if(savedAmountWrap && savedAmount){
             savedAmountWrap.style.display = 'block'
             saleBadge.style.display = 'block'
            savedAmountWrap.innerHTML = savedAmount
          }else{
             savedAmountWrap.style.display = 'none'
             saleBadge.style.display = 'none'
          }
      
          const productSizesDiv = productCardWrapper.querySelector('.product-sizes');
          if (productSizesDiv) {
              const sizeOptions = productSizesDiv.querySelectorAll('.size-option');

              sizeOptions.forEach(sizeOption => {
                  const sizeOptionColor = sizeOption.getAttribute('data-color');
                  if (sizeOptionColor === selectedColor) {
                      sizeOption.classList.remove('hidden');
                  } else {
                      sizeOption.classList.add('hidden');
                  }
              });
          }

          const availableSizeOption = [...productSizesDiv.querySelectorAll('.size-option')]
              .find(sizeOption => sizeOption.getAttribute('data-color') === selectedColor && !sizeOption.classList.contains('sold-out'));

          if (availableSizeOption) {
              productSizesDiv.querySelectorAll('.size-option').forEach(option => option.classList.remove('selected'));
              availableSizeOption.classList.add('selected');
              const selectedVariantId = availableSizeOption.getAttribute('data-variant-id');
              const variantIdInput = productCardWrapper.querySelector('input.product-variant-id');
              const quickAddMobileModalOpener = productCardWrapper.querySelector('.quick-add__submit-mobile');
              if (variantIdInput) {
                  variantIdInput.value = selectedVariantId;
              }
            
              if (quickAddMobileModalOpener) {
                let productUrl = quickAddMobileModalOpener.getAttribute('data-product-url');
                
                productUrl = productUrl.replace(/variant=\d+$/, `variant=${selectedVariantId}`);
                quickAddMobileModalOpener.setAttribute('data-product-url', productUrl);
                if (window.innerWidth <= 767) {
                  quickAddMobileModalOpener.click();
                }
              }
          } else {
            const anyFirstSizeOption = [...productSizesDiv.querySelectorAll('.size-option')]
              .find(sizeOption => sizeOption.getAttribute('data-color') === selectedColor);

            if (anyFirstSizeOption) {
              const selectedFirstVariantId = anyFirstSizeOption.getAttribute('data-variant-id');
              const quickAddMobileModalOpener = productCardWrapper.querySelector('.quick-add__submit-mobile');
              if (quickAddMobileModalOpener) {
                let productUrl = quickAddMobileModalOpener.getAttribute('data-product-url');
                
                productUrl = productUrl.replace(/variant=\d+$/, `variant=${selectedFirstVariantId}`);
                quickAddMobileModalOpener.setAttribute('data-product-url', productUrl);
                if (window.innerWidth <= 767) {
                  quickAddMobileModalOpener.click();
                }
              }
            }
            
          }

          const quickAddButton = productCardWrapper.querySelector('.quick-add__submit');
          if (productSizesDiv && productSizesDiv.querySelectorAll('.size-option').length > 0) {
              const sizeOptions = productSizesDiv.querySelectorAll('.size-option');
              const allSoldOut = [...sizeOptions]
                    .filter(sizeOption => sizeOption.getAttribute('data-color') === selectedColor)
                    .every(sizeOption => sizeOption.classList.contains('sold-out'));

              if (allSoldOut && quickAddButton) {
                  quickAddButton.disabled = true;
                  quickAddButton.querySelector('.quick-add__submit--text-holder').textContent = 'Sold out';
              } else {
                  if (quickAddButton) {
                    quickAddButton.disabled = false;
                    quickAddButton.querySelector('.quick-add__submit--text-holder').textContent = 'ADD TO BAG';
                  }
              }
          } else if (productSizesDiv && productSizesDiv.querySelectorAll('.size-option').length === 0 && variantAvailable === "true") {
              if (quickAddButton) {
                quickAddButton.disabled = false;
                quickAddButton.querySelector('.quick-add__submit--text-holder').textContent = 'ADD TO BAG';
              }
          } else {
              if (quickAddButton) {
                quickAddButton.disabled = true;
                quickAddButton.querySelector('.quick-add__submit--text-holder').textContent = 'Sold out';
              }
          }
      });
    const parentWrapper = swatch.closest('.product-card-wrapper');
    
    if (!parentWrapper) return;  
    const sizeOptions = parentWrapper.querySelectorAll('.size-option');
    const swatchColor = swatch.getAttribute('data-color');

    const matchingSizeOptions = Array.from(sizeOptions).filter(option => 
      option.getAttribute('data-color') === swatchColor
    );  
    const allSoldOut = matchingSizeOptions.every(option => option.classList.contains('sold-out'));

    if (allSoldOut) {
      swatch.classList.add('hidden');
    }      
  });
}
  
document.addEventListener('DOMContentLoaded', function () {
    const colorSwatches = document.querySelectorAll('.color-swatch');
    if (colorSwatches.length > 0) {
      setupColorSwatchEvents(colorSwatches);      
    }
});

function setupSizeOptionEvents(productSizes) {
 
  productSizes.forEach(productSize => {
    const sizeOptions = productSize.querySelectorAll('label.size-option');
    
    if (sizeOptions.length > 0) {
      sizeOptions.forEach(option => {
        option.addEventListener('click', function() {
          // if (this.classList.contains('sold-out')) {
          //   return;
          // }
          const sizePrice = option.getAttribute('data-variant-size-price')
          const selectedVariantId = this.getAttribute('data-variant-id');
          sizeOptions.forEach(sibling => sibling.classList.remove('selected'));
          this.classList.add('selected');
          const productCardWrapper = this.closest('.product-card-wrapper');
          const cardContentPrice = productCardWrapper.querySelector('.price-item') 
          if(sizePrice && cardContentPrice){
            cardContentPrice.innerHTML = sizePrice;
          }
          if (productCardWrapper) {
            const variantInput = productCardWrapper.querySelector('input.product-variant-id');
            if (variantInput) {
              variantInput.value = selectedVariantId;
            }
          }
        });
      });
    }
  });
}

document.addEventListener('DOMContentLoaded', function () {
    const productSizes = document.querySelectorAll('.product-sizes');
    if (productSizes.length > 0) {
      setupSizeOptionEvents(productSizes);      
    }
});